import React, { useState } from "react";
import "react-slideshow-image/dist/styles.css";
import { Fade } from "react-slideshow-image";
import MokUp01 from "./img/mokup_sample_01.png";
import MokUp02 from "./img/mokup_sample_02.png";

const FadeExample = () => {
  const [autoplay, setAutoplay] = useState(true);

  const properties = {
    duration: 2000,
    transitionDuration: 500,
    autoplay: true,
    indicators: false,
    arrows: false,
  };

  const fadeImages = [MokUp01, MokUp02];

  return (
    <div>
      {/* <h2>Fade Effect</h2> */}
      <div className="slide-container">
        <Fade autoplay={autoplay} {...properties}>
          <div
            className="each-fade"
            // style={style}
          >
            <img src={fadeImages[0]} alt="..." />
          </div>
          <div
            className="each-fade"
            // style={style}
          >
            <img src={fadeImages[1]} alt="..." />
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default FadeExample;
